import * as React from 'react';
import { t } from 'i18next';

import { PopupMenu, SidebarModule } from '../../../constants/Enums';
import { VisibilityActions } from '../../../actions/VisibilityActions';
import { Stats } from '../../../utils/Stats';
import { VisibilityStore } from '../../../stores/VisibilityStore';
import { ProjectSettingsStore } from '../../../stores/ProjectSettingsStore';
import { TooltipStore } from '../../../stores/TooltipStore';
import { SelectBoxOption } from '../../../stores/SelectBoxStore';
import { FloorPlanActions } from '../../../actions/FloorPlanActions';
import { GlobalHelper } from '../../../utils/GlobalHelper';
import { ProjectSettingsActions } from '../../../actions/ProjectSettingsActions';
import { ViewSettingsActions } from '../../../actions/ViewSettingsActions';
import { PopupFlagPosition } from '../../../constants/PopupFlagPositions';
import { CoreTooltip } from '../../CoreTooltip';
import { FloorPlanPopup } from './FloorPlanPopup';
import { BasePopupMenu } from '../../popupmenu/BasePopupMenu';

export class FloorPlanPopupInTab extends FloorPlanPopup {
    public render(): JSX.Element {
        return (
            <BasePopupMenu
                defaultValue={null}
                flagPosition={PopupFlagPosition.TOPRIGHT}
                open={this.state.open}
                toggleCallback={this.toggleSelect}
                className="toolbar-button toolbar-floorplan-button"
                options={this.options()}
                title={{label: t('Floor Plan'), className: ''}}
            >
                {this.state.open ? null : (<CoreTooltip config={{label: t('Floor Plan')}}/>)}
            </BasePopupMenu>
        );
    }

    protected toggleSelect = (pValue: boolean) => {
        if (!pValue) {
            VisibilityActions.setPopupMenu(PopupMenu.FLOORPLAN_IN_TAB);
            Stats.sendEvent({
                category: 'Interaction',
                action: 'floorplan'
            });
        } else {
            VisibilityActions.hidePopupMenu(PopupMenu.FLOORPLAN_IN_TAB);
        }
    };

    protected onChange = (): void => {
        this.setState({
            open: VisibilityStore.getState().popupMenu === PopupMenu.FLOORPLAN_IN_TAB,
            floorPlanVisibility: ProjectSettingsStore.getFloorPlanVisibility(),
            activeTooltip: TooltipStore.getState().activeId
        });
    };

    protected options(): Array<SelectBoxOption> {
        return [
            {
                value: 'insert-fp',
                name: t('Insert'),
                className: 'insert-button',
                callback: () => {
                    VisibilityActions.hidePopupMenu(PopupMenu.FLOORPLAN_IN_TAB);
                    FloorPlanActions.getImageFile();
                }
            },
            {
                value: 'toggle-fp',
                name: this.state.floorPlanVisibility ? t('Hide') : t('Unhide'),
                className: this.state.floorPlanVisibility ? ' hide-button' : ' show-button',
                disabled: (GlobalHelper.floorPlan == null || !GlobalHelper.floorPlan.hasTexture()),
                callback: () => {
                    if (ProjectSettingsStore.getFloorPlanVisibility()) {
                        ProjectSettingsActions.hideFloorPlan();
                        FloorPlanPopup.sendEvent('visibilitychange', 'hidden');
                    } else {
                        ProjectSettingsActions.showFloorPlan();
                        FloorPlanPopup.sendEvent('visibilitychange', 'visible');
                    }
                }
            },
            {
                value: 'setup-fp',
                name: t('Setup'),
                className: 'setup-button',
                disabled: GlobalHelper.floorPlan == null || !GlobalHelper.floorPlan.hasTexture() || !this.state.floorPlanVisibility,
                callback: () => {
                    ViewSettingsActions.changeSidebar(SidebarModule.NONE);
                    VisibilityActions.setPopupMenu(PopupMenu.FLOORPLAN_SETUP);
                    FloorPlanPopup.sendEvent('setup');
                }
            }
        ];
    }
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/overlay/floorplan/FloorPlanPopupInTab.tsx